/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { Pageable } from '../model/pageable';
// @ts-ignore
import { PagedModelTipoPraticaRegolaPunteggioDTO } from '../model/paged-model-tipo-pratica-regola-punteggio-dto';
// @ts-ignore
import { TipoPraticaRegolaPunteggioCreationForm } from '../model/tipo-pratica-regola-punteggio-creation-form';
// @ts-ignore
import { TipoPraticaRegolaPunteggioDTO } from '../model/tipo-pratica-regola-punteggio-dto';
// @ts-ignore
import { TipoPraticaRegolaPunteggioListFilter } from '../model/tipo-pratica-regola-punteggio-list-filter';
// @ts-ignore
import { TipoPraticaRegolaPunteggioPatchForm } from '../model/tipo-pratica-regola-punteggio-patch-form';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    TipoPraticaRegolaPunteggioControllerServiceInterface,
    CreateTipoPraticaRegolaPunteggioRequestParams,
    DeleteTipoPraticaRegolaPunteggioRequestParams,
    GetTipoPraticaRegolaPunteggioRequestParams,
    ListTipoPraticaRegolePunteggioRequestParams,
    UpdateTipoPraticaRegolaPunteggioRequestParams
} from './tipo-pratica-regola-punteggio-controller.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class TipoPraticaRegolaPunteggioControllerService extends BaseService implements TipoPraticaRegolaPunteggioControllerServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Crea una nuova regola di punteggio sotto la categoria indicata
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public createTipoPraticaRegolaPunteggio(requestParameters: CreateTipoPraticaRegolaPunteggioRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TipoPraticaRegolaPunteggioDTO>;
    public createTipoPraticaRegolaPunteggio(requestParameters: CreateTipoPraticaRegolaPunteggioRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TipoPraticaRegolaPunteggioDTO>>;
    public createTipoPraticaRegolaPunteggio(requestParameters: CreateTipoPraticaRegolaPunteggioRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TipoPraticaRegolaPunteggioDTO>>;
    public createTipoPraticaRegolaPunteggio(requestParameters: CreateTipoPraticaRegolaPunteggioRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling createTipoPraticaRegolaPunteggio.');
        }
        const idCategoria = requestParameters?.idCategoria;
        if (idCategoria === null || idCategoria === undefined) {
            throw new Error('Required parameter idCategoria was null or undefined when calling createTipoPraticaRegolaPunteggio.');
        }
        const tipoPraticaRegolaPunteggioCreationForm = requestParameters?.tipoPraticaRegolaPunteggioCreationForm;
        if (tipoPraticaRegolaPunteggioCreationForm === null || tipoPraticaRegolaPunteggioCreationForm === undefined) {
            throw new Error('Required parameter tipoPraticaRegolaPunteggioCreationForm was null or undefined when calling createTipoPraticaRegolaPunteggio.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regola-punteggio-categorie/${this.configuration.encodeParam({name: "idCategoria", value: idCategoria, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regole`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TipoPraticaRegolaPunteggioDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: tipoPraticaRegolaPunteggioCreationForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Elimina una regola di punteggio (cascade su predicati/fasce)
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole/{idRegola}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public deleteTipoPraticaRegolaPunteggio(requestParameters: DeleteTipoPraticaRegolaPunteggioRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteTipoPraticaRegolaPunteggio(requestParameters: DeleteTipoPraticaRegolaPunteggioRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteTipoPraticaRegolaPunteggio(requestParameters: DeleteTipoPraticaRegolaPunteggioRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteTipoPraticaRegolaPunteggio(requestParameters: DeleteTipoPraticaRegolaPunteggioRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling deleteTipoPraticaRegolaPunteggio.');
        }
        const idCategoria = requestParameters?.idCategoria;
        if (idCategoria === null || idCategoria === undefined) {
            throw new Error('Required parameter idCategoria was null or undefined when calling deleteTipoPraticaRegolaPunteggio.');
        }
        const idRegola = requestParameters?.idRegola;
        if (idRegola === null || idRegola === undefined) {
            throw new Error('Required parameter idRegola was null or undefined when calling deleteTipoPraticaRegolaPunteggio.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regola-punteggio-categorie/${this.configuration.encodeParam({name: "idCategoria", value: idCategoria, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regole/${this.configuration.encodeParam({name: "idRegola", value: idRegola, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Dettaglio di una regola di punteggio
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole/{idRegola}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getTipoPraticaRegolaPunteggio(requestParameters: GetTipoPraticaRegolaPunteggioRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TipoPraticaRegolaPunteggioDTO>;
    public getTipoPraticaRegolaPunteggio(requestParameters: GetTipoPraticaRegolaPunteggioRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TipoPraticaRegolaPunteggioDTO>>;
    public getTipoPraticaRegolaPunteggio(requestParameters: GetTipoPraticaRegolaPunteggioRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TipoPraticaRegolaPunteggioDTO>>;
    public getTipoPraticaRegolaPunteggio(requestParameters: GetTipoPraticaRegolaPunteggioRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling getTipoPraticaRegolaPunteggio.');
        }
        const idCategoria = requestParameters?.idCategoria;
        if (idCategoria === null || idCategoria === undefined) {
            throw new Error('Required parameter idCategoria was null or undefined when calling getTipoPraticaRegolaPunteggio.');
        }
        const idRegola = requestParameters?.idRegola;
        if (idRegola === null || idRegola === undefined) {
            throw new Error('Required parameter idRegola was null or undefined when calling getTipoPraticaRegolaPunteggio.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regola-punteggio-categorie/${this.configuration.encodeParam({name: "idCategoria", value: idCategoria, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regole/${this.configuration.encodeParam({name: "idRegola", value: idRegola, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TipoPraticaRegolaPunteggioDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista paginata delle regole di punteggio della categoria (filtri: ambito, modalita_mappa, aggregatore)
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listTipoPraticaRegolePunteggio(requestParameters: ListTipoPraticaRegolePunteggioRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelTipoPraticaRegolaPunteggioDTO>;
    public listTipoPraticaRegolePunteggio(requestParameters: ListTipoPraticaRegolePunteggioRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelTipoPraticaRegolaPunteggioDTO>>;
    public listTipoPraticaRegolePunteggio(requestParameters: ListTipoPraticaRegolePunteggioRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelTipoPraticaRegolaPunteggioDTO>>;
    public listTipoPraticaRegolePunteggio(requestParameters: ListTipoPraticaRegolePunteggioRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling listTipoPraticaRegolePunteggio.');
        }
        const idCategoria = requestParameters?.idCategoria;
        if (idCategoria === null || idCategoria === undefined) {
            throw new Error('Required parameter idCategoria was null or undefined when calling listTipoPraticaRegolePunteggio.');
        }
        const filter = requestParameters?.filter;
        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling listTipoPraticaRegolePunteggio.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling listTipoPraticaRegolePunteggio.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'filter',
            <any>filter,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regola-punteggio-categorie/${this.configuration.encodeParam({name: "idCategoria", value: idCategoria, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regole`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelTipoPraticaRegolaPunteggioDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Replace di una regola di punteggio (richiede version)
     * @endpoint put /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole/{idRegola}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public updateTipoPraticaRegolaPunteggio(requestParameters: UpdateTipoPraticaRegolaPunteggioRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TipoPraticaRegolaPunteggioDTO>;
    public updateTipoPraticaRegolaPunteggio(requestParameters: UpdateTipoPraticaRegolaPunteggioRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TipoPraticaRegolaPunteggioDTO>>;
    public updateTipoPraticaRegolaPunteggio(requestParameters: UpdateTipoPraticaRegolaPunteggioRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TipoPraticaRegolaPunteggioDTO>>;
    public updateTipoPraticaRegolaPunteggio(requestParameters: UpdateTipoPraticaRegolaPunteggioRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling updateTipoPraticaRegolaPunteggio.');
        }
        const idCategoria = requestParameters?.idCategoria;
        if (idCategoria === null || idCategoria === undefined) {
            throw new Error('Required parameter idCategoria was null or undefined when calling updateTipoPraticaRegolaPunteggio.');
        }
        const idRegola = requestParameters?.idRegola;
        if (idRegola === null || idRegola === undefined) {
            throw new Error('Required parameter idRegola was null or undefined when calling updateTipoPraticaRegolaPunteggio.');
        }
        const tipoPraticaRegolaPunteggioPatchForm = requestParameters?.tipoPraticaRegolaPunteggioPatchForm;
        if (tipoPraticaRegolaPunteggioPatchForm === null || tipoPraticaRegolaPunteggioPatchForm === undefined) {
            throw new Error('Required parameter tipoPraticaRegolaPunteggioPatchForm was null or undefined when calling updateTipoPraticaRegolaPunteggio.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regola-punteggio-categorie/${this.configuration.encodeParam({name: "idCategoria", value: idCategoria, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regole/${this.configuration.encodeParam({name: "idRegola", value: idRegola, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TipoPraticaRegolaPunteggioDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: tipoPraticaRegolaPunteggioPatchForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
